import React from 'react';
import Header from '../Header/Header';

const Deals = () => {
    return (
        <div className="container">

        <Header></Header>

        <h3>This route is coming soon</h3>
            
        </div>
    );
};

export default Deals;